import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {StorageService} from 'src/shared/services/storage/storage.service';
import {DialogCopyFileComponent} from '../dialog-copy-file/dialog-copy-file.component';
import {DialogDownloadFileComponent} from '../dialog-download-file/dialog-download-file.component';
import {DialogEditFileComponent} from '../dialog-edit-file/dialog-edit-file.component';
import {DialogMoveFileComponent} from '../dialog-move-file/dialog-move-file.component';
import {NodesService} from '../services/nodes.service';

@Component({
  selector: 'app-menu-file-options',
  templateUrl: './menu-file-options.component.html',
  styleUrls: ['./menu-file-options.component.scss']
})
export class MenuFileOptionsComponent implements OnInit {
  public loading: boolean;
  public ariane: any[] = [];
  public entries: any[] = [];
  @Input() private elementId;
  @Input() private parentId;
  @Input() private fileName;
  @Input() public isPublic: boolean;
  @Input() public originalMimeType: string;
  @Input() public mimeType: string;
  constructor(
    private dialog: MatDialog,
    private nodeService: NodesService,
    private router: Router,
    private storage: StorageService
  ) {}

  ngOnInit() {}

  public deleteItem() {
    this.loading = true;
    this.nodeService
      .delete(this.elementId)
      .then(res => {
        this.goToParent();
      })
      .finally(() => (this.loading = false));
  }

  public moveFile() {
    const dialogRef = this.dialog.open(DialogMoveFileComponent, {
      width: '60%',
      height: '70%',
      data: {
        file: { name: this.fileName, id: this.elementId }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.goToParent();
    });
  }

  public copyFile() {
    const dialogRef = this.dialog.open(DialogCopyFileComponent, {
      width: '60%',
      height: '70%',
      data: {
        file: { name: this.fileName, id: this.elementId }
      }
    });
  }

  public editFile() {
    const dialogRef = this.dialog.open(DialogEditFileComponent, {
      width: '40%',
      height: '40%',
      data: {
        file: { name: this.fileName, id: this.elementId }
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  editonlyoffice() {
    let url = '';
    const token = this.storage.getAsync({ key: 'token' });
    // url='http://localhost:8180/share/page/user/admin/dashboard';
    url = `http://localhost:8180/share/page/site/${
      this.nodeService.rootSite
    }/onlyoffice-edit?${'nodeRef=workspace://SpacesStore/' +
      this.elementId}&new=`;
    url += '&attachment=true&alf_ticket=' + token;
    window.open(url, '_blank');
  }

  public downloadFile() {
    const dialogRef = this.dialog.open(DialogDownloadFileComponent, {
      width: '60%',
      height: '40%',
      data: {
        file: { name: this.fileName, id: this.elementId },
        isPublic: this.isPublic
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  private goToParent() {
    this.router.navigate(['/', 'home', 'my-libraries', 'lib', this.parentId]);
  }
}
